import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edit-business-layout" }
const _hoisted_2 = { class: "edit-business-layout__title" }
const _hoisted_3 = { class: "edit-business-layout__header__tab" }

import RegisterBusinessPageTab from '@/corePagesModule/components/RegisterBusinessPageTab.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditPageLayout',
  props: {
    title: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(RegisterBusinessPageTab)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})